export const tasksKeys = {
  all: ['tasks'] as const,
  my: (accountId: string) => [...tasksKeys.all, 'my', accountId] as const,
  allTasks: () => [...tasksKeys.all, 'all'] as const,
}
